<template>
  <div class="message-edit">
    <div class="form-group">
      <textarea 
        v-model="editableMessage.message" 
        class="input w-full" 
        rows="3" 
        v-bind:class="{ 'input-error': errors.message }">
      </textarea>
      <div class="input-error-message" v-if="errors.message">{{ errors.message[0] }}</div>
    </div>
    
    <div class="flex gap-2 mt-2">
      <button @click="updateMessage" class="btn btn-primary btn-small" :disabled="saving">
        <span v-if="saving">Aktualisieren...</span>
        <span v-else>Aktualisieren</span>
      </button>
      <button @click="cancelEdit" class="btn btn-secondary btn-small">
        Abbrechen
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message', 'dossier'],
  data() {
    return {
      editableMessage: {
        message: this.message.message
      },
      errors: {},
      saving: false
    }
  },
  methods: {
    updateMessage: function () {
      if (!this.editableMessage.message.trim()) {
        this.errors = { message: ['Notiz darf nicht leer sein'] }
        return
      }

      this.saving = true
      this.errors = {}

      const url = `/diesel_dossiers/${this.dossier.id}/messages/${this.message.id}`
      
      this.$http.put(url, { message: this.editableMessage }).then(response => {
        Vue.$toast.success('Notiz wurde aktualisiert.')
        this.saving = false
        this.$emit('message-updated', response.body)
      }, response => {
        this.saving = false
        if (response.status === 422) {
          this.errors = response.body
        } else {
          Vue.$toast.error('Fehler beim Aktualisieren der Notiz.')
        }
      })
    },
    
    cancelEdit: function () {
      this.editableMessage.message = this.message.message
      this.errors = {}
      this.$emit('cancelled')
    }
  }
}
</script>